import type { Degree } from '../../../../../domain/Degree';
import type { Percent } from '../../../../../domain/Percent';
import type { Voltage } from '../../../../../domain/Voltage';
import type { AttentionStatusType } from '../../../../AttentionStatus';
import type { ForMessaging } from '../../../../AttentionStatusRepository';
import type { EvaluatedResult } from '../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../RulesProvider';
import type { ForEnergyConsumerEvaluation } from '../../../gridElements/energyConsumer/forEnergyConsumerEvaluation';
import { VoltageCosinePhiEvaluation } from './propertiesEvaluations/VoltageCosinePhiEvaluation';
import { VoltageDiffNominalEvaluation } from './propertiesEvaluations/VoltageDiffNominalEvaluation';
import { VoltageDiffTransformerEndEvaluation } from './propertiesEvaluations/VoltageDiffTransformerEndEvaluation';
import { VoltageDiffTransformerEndPercentEvaluation } from './propertiesEvaluations/VoltageDiffTransformerEndPercentEvaluation';
import { VoltageEvaluation } from './propertiesEvaluations/VoltageEvaluation';

export class EnergyConsumerEvaluationEngine
  implements ForEnergyConsumerEvaluation
{
  constructor(private readonly ruleProvider: ForRuleProviding) {}

  public evaluateVoltage(voltage: number): EvaluatedResult<Voltage> {
    return new VoltageEvaluation(this.ruleProvider).evaluate(voltage);
  }

  public evaluateVoltageDiffTransformerEndPercent(
    voltageDiffPercent: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Percent> {
    const evaluation = new VoltageDiffTransformerEndPercentEvaluation(
      this.ruleProvider
    ).evaluate(voltageDiffPercent);

    messenger.send(
      evaluation.status,
      this.evaluateVoltageDiffTransformerEndPercent.name
    );
    return evaluation.toEvaluatedResult();
  }

  public evaluateVoltageCosinePhi(
    voltageCosinePhi: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Degree> {
    const evaluation = new VoltageCosinePhiEvaluation(
      this.ruleProvider
    ).evaluate(voltageCosinePhi);
    messenger.send(evaluation.status, this.evaluateVoltageCosinePhi.name);
    return evaluation.toEvaluatedResult();
  }

  public evaluateVoltageDiffNominal(
    voltageDiffNominal: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Voltage> {
    const evaluation = new VoltageDiffNominalEvaluation(
      this.ruleProvider
    ).evaluate(voltageDiffNominal);
    messenger.send(evaluation.status, this.evaluateVoltageDiffNominal.name);
    return evaluation.toEvaluatedResult();
  }

  public evaluateVoltageDiffTransformerEnd(
    voltageDiffNominal: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Voltage> {
    const evaluation = new VoltageDiffTransformerEndEvaluation(
      this.ruleProvider
    ).evaluate(voltageDiffNominal);

    messenger.send(
      evaluation.status,
      this.evaluateVoltageDiffTransformerEnd.name
    );
    return evaluation.toEvaluatedResult();
  }
}
